// extracted by mini-css-extract-plugin
module.exports = {"CreateAccount":"_3smJH","MinHeight":"_33clR","container768":"_27LGc","topSpace80":"_1vjrW","title":"_2mBAU","congratulations":"Xvrcq","topSpace50":"_2Fjam","nextButton":"_2zEAe"};